import { FC, ReactNode } from 'react';
import Page from '../../components/page';
import { createUseStyles } from 'react-jss';
import Card from '@/components/card';
import { Stack } from '@mui/material';
import classNames from 'classnames';
import { getBreakpoint } from '@/theme';

interface Props {
  children: ReactNode;
  height?: number | string;
  width?: number | string;
  className?: string;
}

const useStyles = createUseStyles({
  pageCard: {
    margin: '8px auto',
    width: '90%',
    maxWidth: ({ width }: { width: number | string }) => width,
    padding: 24,
    flexShrink: 0,
  },
  [getBreakpoint('sm')]: {
    pageCard: {
      width: '98%',
      padding: 16,
    },
  },
});

const PageCard: FC<Props> = ({ children, height, width = 500, className }) => {
  const styles = useStyles({ width });
  const compClass = classNames(styles.pageCard, className);

  return (
    <Page>
      <Card className={compClass}>
        <Stack alignItems="center" justifyContent="center" gap={2} minHeight={height}>
          {children}
        </Stack>
      </Card>
    </Page>
  );
};

export default PageCard;
